import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './theme';
import MainPage from './pages/MainPage';
import { WidthProvider } from './context/WidthContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WidthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <MainPage />
        </BrowserRouter>
      </WidthProvider>
    </ThemeProvider>
  );
}

export default App;
